import { ReactElement, ReactNode } from 'react';
import {
    iconAnalytics,
    iconAssets,
    iconComponents,
    iconEnivironments,
    iconPages,
    iconResources,
    iconSettings,
    iconThemes,
    iconLayers,
    iconAnalyticsActive,
    iconAssetsActive,
    iconComponentsActive,
    iconEnivironmentsActive,
    iconPagesActive,
    iconResourcesActive,
    iconSettingsActive,
    iconThemesActive,
    iconLayersActive,
    iconDocuments,
    iconDocumentsActive,
    newFolder,
    newFolderActive,
    newPage,
    newPageActive,
    refComponentSvg,
    refComponentActiveSvg,
    iconContentList,
    iconContentListActive,
    iconSlideSorterActive,
    iconSlideSorter,
} from '../../../assets/images';
import {
    LayersSideBarComp,
    WidgetSideBar,
    ComponentsSidebar,
    SlidesSidebarComp,
} from './PageNavComponents';

export interface SiteNavOption {
    name: string;
    path: string;
    icon: string;
    activeIcon: string;
}

export interface PageNavOption {
    name: string;
    icon: string;
    activeIcon: string;
    component: ((ReactElement<any, any> & ReactNode) & ReactNode) | null;
    showOnSecondLeftSidebar: boolean;
}

export const siteNavOptions: SiteNavOption[] = [
    {
        path: `/admin/pages`,
        name: 'Pages',
        icon: iconPages,
        activeIcon: iconPagesActive,
    },
    {
        path: `/admin/slidedecks`,
        name: 'Slidedecks',
        icon: iconSlideSorter,
        activeIcon: iconSlideSorterActive,
    },
    {
        path: `/admin/environments`,
        name: 'Environments Diff',
        icon: iconEnivironments,
        activeIcon: iconEnivironmentsActive,
    },
    {
        path: `/admin/themes`,
        name: 'Themes',
        icon: iconThemes,
        activeIcon: iconThemesActive,
    },
    {
        path: `/admin/documents`,
        name: 'Documents',
        icon: iconDocuments,
        activeIcon: iconDocumentsActive,
    },
    {
        path: `/admin/media`,
        name: 'Media',
        icon: iconAssets,
        activeIcon: iconAssetsActive,
    },
    {
        path: `/admin/resources`,
        name: 'Resources',
        icon: iconResources,
        activeIcon: iconResourcesActive,
    },
    {
        path: `/admin/components`,
        name: 'Components',
        icon: iconComponents,
        activeIcon: iconComponentsActive,
    },
    {
        path: `/admin/analytics`,
        name: 'Analytics',
        icon: iconAnalytics,
        activeIcon: iconAnalyticsActive,
    },
    {
        path: `/admin/content-list`,
        name: 'Content List',
        icon: iconContentList,
        activeIcon: iconContentListActive,
    },
    {
        path: `/admin/settings`,
        name: 'Settings',
        icon: iconSettings,
        activeIcon: iconSettingsActive,
    },
];

export const pageNavOptions: PageNavOption[] = [
    {
        name: 'Widget',
        icon: iconComponents,
        activeIcon: iconComponentsActive,
        component: <WidgetSideBar />,
        showOnSecondLeftSidebar: true,
    },
    {
        name: 'Components',
        icon: refComponentSvg,
        activeIcon: refComponentActiveSvg,
        component: <ComponentsSidebar />,
        showOnSecondLeftSidebar: true,
    },
    {
        name: 'Layers',
        icon: iconLayers,
        activeIcon: iconLayersActive,
        component: <LayersSideBarComp />,
        showOnSecondLeftSidebar: true,
    },
    {
        name: 'Slides',
        icon: iconSlideSorter,
        activeIcon: iconSlideSorterActive,
        component: <SlidesSidebarComp />,
        showOnSecondLeftSidebar: true,
    },
];

export interface PageActionOption {
    name: string;
    icon: string;
    activeIcon: string;
}

export const pageActionOptions: PageActionOption[] = [
    {
        name: 'folder',
        icon: newFolder,
        activeIcon: newFolderActive,
    },
    {
        name: 'page',
        icon: newPage,
        activeIcon: newPageActive,
    },
];

export const themeActionOptions: PageActionOption[] = [
    {
        name: 'folder',
        icon: newFolder,
        activeIcon: newFolderActive,
    },
    {
        name: 'theme',
        icon: newPage,
        activeIcon: newPageActive,
    },
];

export const mediaActionOptions: PageActionOption[] = [
    {
        name: 'folder',
        icon: newFolder,
        activeIcon: newFolderActive,
    },
    {
        name: 'media',
        icon: newPage,
        activeIcon: newPageActive,
    },
];

export const componentActionOptions: PageActionOption[] = [
    {
        name: 'folder',
        icon: newFolder,
        activeIcon: newFolderActive,
    },
    {
        name: 'component',
        icon: newPage,
        activeIcon: newPageActive,
    },
];

export const slidedeckActionOptions: PageActionOption[] = [
    {
        name: 'folder',
        icon: newFolder,
        activeIcon: newFolderActive,
    },
    {
        name: 'slidedeck',
        icon: newPage,
        activeIcon: newPageActive,
    },
];

export const resourceActionOptions: PageActionOption[] = [
    {
        name: 'locale',
        icon: newFolder,
        activeIcon: newFolderActive,
    },
    {
        name: 'resource',
        icon: newPage,
        activeIcon: newPageActive,
    },
];

export const contentListActionOptions: PageActionOption[] = [
    {
        name: 'folder',
        icon: newFolder,
        activeIcon: newFolderActive,
    },
    {
        name: 'content list',
        icon: newPage,
        activeIcon: newPageActive,
    },
];
